import { createTransform } from 'redux-persist'

export const stripPasswordFromRegister = createTransform(
  (inboundState: any) => {
    if (!inboundState || typeof inboundState.deleteIn !== 'function') return inboundState
    return inboundState.deleteIn(['formValues', 'password'])
  },
  (outboundState: any) => outboundState,
  { whitelist: ['register'] },
)
